import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import Container from 'typedi'
import Notification from '@/modules/common/services/notification.service'

@Component({
  name: 'GtrGlossary'
})

export default class GtrGlossary extends Vue {
    @Prop({ required: true, type: Array, default: '' })
    glossaryItems: Array<object> | undefined

    @Prop()
    tooltip: any

    @Prop({ type: Boolean, default: true })
    showReceiptButton!: boolean

    data () {
      return {
        tabNames: ['General', 'Advanced'],
        tab: null,
        generalItems: [],
        advancedItems: [],
        search: ''
      }
    }

    @Watch('glossaryItems', { immediate: true })
    onGlossaryItemsChange (payload: any) {
      // The picker reflects exactly the current list: replace rather than accumulate
      this.$data.generalItems = []
      this.$data.advancedItems = []
      // Internal/system fields that have no value as merge fields (GTR-4394), hidden from both tabs
      const excludedInternalFields = [
        'a2z_additional_badge',
        'a2z_adhoc_add',
        'a2z_booth_area',
        'badge_print_eligibility_override',
        'comped',
        'comped_secret',
        'deleted_by',
        'deletion_reason',
        'devices_micro_scanner',
        'devices_pro_scanner',
        'devices_mobile_app',
        'kiosk_check_in_message',
        'mc_trade_raw',
        'onsite_device',
        'onsite_device_status',
        'onsite_notes',
        'onsite_phone',
        'pay_for_another'
      ]
      const excludedFromGeneral = [...excludedInternalFields, 'language', 'profile_photo', 'a2z_id', 'can_export_certificates', 'exported_certificate']
      const excludedFromAdvanced = [...excludedInternalFields, 'payment_vault_id', 'sync_id', 'update_from_sync', 'sync_updated', 'sync_updated_id', 'jot_id', 'jot_modified_date', 'jot_push_date', 'event_a2z_data', 'event_database', 'event_created_by', 'event_deleted_at', 'event_deletion_reason', 'event_last_jot_sync', 'event_migrations_md5']
      if (payload.length) {
        for (let i = 0; i < payload.length; i++) {
          if (payload[i].advanced === 1) {
            const uuid = (payload[i].field_details && payload[i].field_details.hasOwnProperty('option_group_uuid')) ? payload[i].field_details.option_group_uuid : payload[i].field
            if (this.$data.advancedItems.every(item => item.uuid !== uuid) && excludedFromAdvanced.every(item => item !== uuid)) {
              this.$data.advancedItems.push({
                label: payload[i].label,
                uuid
              })
            }
            this.$data.advancedItems.sort((a, b) => a.label >= b.label ? 1 : -1)
          } else {
            const uuid = (payload[i].field_details && payload[i].field_details.hasOwnProperty('option_group_uuid')) ? payload[i].field_details.option_group_uuid : payload[i].field
            if (this.$data.generalItems.every(item => item.uuid !== uuid) && excludedFromGeneral.every(item => item !== uuid)) {
              this.$data.generalItems.push({
                label: payload[i].label,
                uuid
              })
            }
            this.$data.generalItems.sort((a, b) => a.label >= b.label ? 1 : -1)
          }
        }
        if (this.showReceiptButton) {
          this.$data.advancedItems.push({
            label: 'Send a Receipt',
            uuid: 'receipt_button'
          })
        }
      }
    }

    onCopy () {
      Container.get(Notification).success('Successfully copied uuid.')
    }

    onError () {
      Container.get(Notification).error('There was an error copying the uuid. Please refresh and try again.')
    }

    get filterGeneralFieldsWithSearch () {
      return this.filterFields(this.$data.generalItems)
    }

    get filterAdvancedFieldsWithSearch () {
      return this.filterFields(this.$data.advancedItems)
    }

    private filterFields (fields: any) {
      const returnFields: any = []
      for (const fieldIndex in fields) {
        const field = fields[fieldIndex]
        if (this.$data.search === '' || field.label.toLowerCase().includes(this.$data.search.toLowerCase())) {
          returnFields.push(field)
        }
      }
      return returnFields
    }
}
